/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuctionManagementEditAuctionBidResponse } from './AuctionManagementEditAuctionBidResponse';

export type AuctionManagementEditAuctionBidResponseApiRespoonse = {
    data?: AuctionManagementEditAuctionBidResponse;
    status?: AuctionManagementEditAuctionBidResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuctionManagementEditAuctionBidResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

